import {
  FilterDocumentDateFilter,
  FilterDocumentDateFilterTypes,
  Timestamp,
  WeekDays,
} from '@griply/types';
import { endOfDay, startOfDay } from 'date-fns';

import { calculateDeadlinePresetDates } from '../calculate-deadline-preset-dates';

export type MatchesDateFilterOptions = {
  today: Timestamp;
  weekStartsOn: WeekDays;
};

export const matchesDateFilter = (
  date: Timestamp | null | undefined,
  filter: FilterDocumentDateFilter | null | undefined,
  { today, weekStartsOn }: MatchesDateFilterOptions,
): boolean => {
  if (!filter?.type) {
    return true;
  }

  if (filter.type === FilterDocumentDateFilterTypes.HasDeadline) {
    return !!date;
  }

  if (filter.type === FilterDocumentDateFilterTypes.NoDeadline) {
    return !date;
  }

  if (!date) {
    return false;
  }

  if (filter.type === FilterDocumentDateFilterTypes.Custom) {
    const start = filter.custom?.start
      ? startOfDay(filter.custom.start)
      : undefined;
    const end = filter.custom?.end ? endOfDay(filter.custom.end) : undefined;

    if (start && date < start) {
      return false;
    }

    return !(end && date > end);
  }

  const range = calculateDeadlinePresetDates(filter.type, {
    today,
    weekStartsOn,
  });
  if (!range) {
    return true;
  }

  const start = range.strictStart ?? range.start;
  if (start && date < start) {
    return false;
  }

  return date <= range.end;
};
